/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CampaignWrapperListEntryFromJSON, CampaignWrapperListEntryToJSON, MetaDataFromJSON, MetaDataToJSON, PageRequestFromJSON, PageRequestToJSON, } from './';
export function PagedResponseOfCampaignWrapperListEntryFromJSON(json) {
    return PagedResponseOfCampaignWrapperListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfCampaignWrapperListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(CampaignWrapperListEntryFromJSON)),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage'])
    };
}
export function PagedResponseOfCampaignWrapperListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nextPage': PageRequestToJSON(value.nextPage),
        'numberOfElements': value.numberOfElements,
        'totalElements': value.totalElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(CampaignWrapperListEntryToJSON)),
        'metaData': MetaDataToJSON(value.metaData),
        'hasNext': value.hasNext,
        'size': value.size,
        'page': value.page,
        'hasPrevious': value.hasPrevious,
        'previousPage': PageRequestToJSON(value.previousPage)
    };
}
